/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Geometry of the customized results area, WKT format, must be WGS84.
 * @export
 * @interface PatchedWaterQualityCustomizedResultAreaGeometry
 */
export interface PatchedWaterQualityCustomizedResultAreaGeometry {
  /**
   *
   */
  type?: PatchedWaterQualityCustomizedResultAreaGeometryTypeEnum;
  /**
   *
   */
  coordinates?: Array<Array<Array<number>>>;
}

/**
 * @export
 */
export const PatchedWaterQualityCustomizedResultAreaGeometryTypeEnum = {
  Polygon: "Polygon",
} as const;
export type PatchedWaterQualityCustomizedResultAreaGeometryTypeEnum =
  (typeof PatchedWaterQualityCustomizedResultAreaGeometryTypeEnum)[keyof typeof PatchedWaterQualityCustomizedResultAreaGeometryTypeEnum];

/**
 * Check if a given object implements the PatchedWaterQualityCustomizedResultAreaGeometry interface.
 */
export function instanceOfPatchedWaterQualityCustomizedResultAreaGeometry(
  value: object
): value is PatchedWaterQualityCustomizedResultAreaGeometry {
  return true;
}

export function PatchedWaterQualityCustomizedResultAreaGeometryFromJSON(
  json: any
): PatchedWaterQualityCustomizedResultAreaGeometry {
  return PatchedWaterQualityCustomizedResultAreaGeometryFromJSONTyped(json, false);
}

export function PatchedWaterQualityCustomizedResultAreaGeometryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedWaterQualityCustomizedResultAreaGeometry {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    coordinates: json["coordinates"] == null ? undefined : json["coordinates"],
  };
}

export function PatchedWaterQualityCustomizedResultAreaGeometryToJSON(
  json: any
): PatchedWaterQualityCustomizedResultAreaGeometry {
  return PatchedWaterQualityCustomizedResultAreaGeometryToJSONTyped(json, false);
}

export function PatchedWaterQualityCustomizedResultAreaGeometryToJSONTyped(
  value?: PatchedWaterQualityCustomizedResultAreaGeometry | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
